import {
  Dropzone_default,
  index_module_default,
  useDamViewModel,
  withDamViewModel
} from "./chunk-JIKNAPG2.js";
import {
  Folder_default,
  HomeUtils_default
} from "./chunk-EEKDERPK.js";
import {
  __publicField
} from "./chunk-XEO3YXBM.js";

// src/integration/lib/AesirXDamComponent.jsx
import React11, { Component as Component2 } from "react";
import {
  DAM_ASSETS_API_FIELD_KEY,
  DAM_ASSETS_FIELD_KEY as DAM_ASSETS_FIELD_KEY4,
  DAM_COLLECTION_FIELD_KEY as DAM_COLLECTION_FIELD_KEY2
} from "aesirx-lib";
import { observer as observer4 } from "mobx-react";
import { withTranslation as withTranslation3 } from "react-i18next";

// src/components/ComponentNoData/index.jsx
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
var ComponentNoData = class extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { className, createAssets, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: className ? className : "text-center h-100 d-flex flex-column justify-content-center align-items-center"
      },
      /* @__PURE__ */ React.createElement(Dropzone_default, { isBtn: false, noDrag: false, createAssets, noClick: true }, /* @__PURE__ */ React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100 w-100" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { className: "fs-4 text-blue-6 fw-semibold" }, t("txt_drop_files_anywhere_to_upload")), /* @__PURE__ */ React.createElement("p", { className: "fs-5 text-gray" }, t("txt_or")), /* @__PURE__ */ React.createElement(Dropzone_default, { noDrag: true, isBtn: true, createAssets }, /* @__PURE__ */ React.createElement("p", { className: "text-blue-6 btn fw-semibold bg-white btn-white border-1 mx-auto w-248" }, t("txt_select_file")), /* @__PURE__ */ React.createElement("p", { className: "text-gray-600 fw-normal pt-1" }, t("maximum_upload_size"))))))
    );
  }
};
var ComponentNoData_default = withTranslation()(ComponentNoData);

// src/integration/lib/AesirXDamComponent.jsx
import { Spinner as Spinner2, PAGE_STATUS as PAGE_STATUS2, Image as Image2 } from "aesirx-uikit";

// src/components/Table/index.jsx
import React9, { useEffect as useEffect2, useMemo as useMemo2 } from "react";
import { useTable } from "react-table";
import { DAM_ASSETS_FIELD_KEY as DAM_ASSETS_FIELD_KEY3 } from "aesirx-lib";
import { useTranslation as useTranslation3, withTranslation as withTranslation2 } from "react-i18next";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// esbuild-scss-modules-plugin:./table.module.scss
var digest = "11093f3b05271b87231f3485b7334afc373f9acefa3644257c3bca4e7f346f23";
var classes = { "btn": "_btn_w660y_5", "btn_toggle": "_btn_toggle_w660y_15", "col_thumb_folder": "_col_thumb_folder_w660y_19", "col_thumb": "_col_thumb_w660y_19", "w_112": "_w_112_w660y_27", "w_272": "_w_272_w660y_31", "w_136": "_w_136_w660y_35", "image_thumb": "_image_thumb_w660y_39", "active": "_active_w660y_50", "inactive": "_inactive_w660y_54", "checkbox": "_checkbox_w660y_58", "count": "_count_w660y_68", "item_hover": "_item_hover_w660y_76" };
var css = `/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
._btn_w660y_5 {
  width: 35px;
  height: 35px;
  margin-right: 5px;
  margin-bottom: 5px;
}
._btn_w660y_5:last-child {
  margin-right: 0;
}

._btn_toggle_w660y_15:after {
  display: none !important;
}

._col_thumb_folder_w660y_19 {
  height: 220px;
}

._col_thumb_w660y_19 {
  height: 248px;
}

._w_112_w660y_27 {
  min-width: 112px;
}

._w_272_w660y_31 {
  min-width: 272px;
}

._w_136_w660y_35 {
  min-width: 136px;
}

._image_thumb_w660y_39 {
  width: 40px;
  height: 40px;
  overflow: hidden;
}
._image_thumb_w660y_39 img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

._active_w660y_50 {
  fill: var(--bs-white);
}

._inactive_w660y_54 {
  fill: var(--bs-blue-9);
}

._checkbox_w660y_58 {
  width: 16px;
  height: 16px;
  margin: 0 auto;
}
._checkbox_w660y_58 input {
  width: 100%;
  height: 100%;
}

._count_w660y_68 {
  position: absolute;
  width: 32px;
  height: 32px;
  top: 16px;
  right: 16px;
}

._item_hover_w660y_76:hover {
  border: 1px solid var(--bs-green);
}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement("style");
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();
var table_module_default = classes;

// src/components/ChooseAnAction/index.jsx
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react";
import React2, { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
var CustomToggle = React2.forwardRef(({ onClick }, ref) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ React2.createElement(
    "div",
    {
      ref,
      onClick: (e) => {
        e.preventDefault();
        onClick(e);
      },
      className: "d-flex align-items-center text-decoration-none cursor-pointer choose-an-action justify-content-between w-100 h-100 px-3 mt-n1"
    },
    /* @__PURE__ */ React2.createElement("div", { className: "pe-5 pt-1 pe-none" }, /* @__PURE__ */ React2.createElement("p", { className: "mb-0 text-body fw-normal fs-14" }, t("txt_choose_an_action"))),
    /* @__PURE__ */ React2.createElement("i", { className: "icons text-green pe-none" }, /* @__PURE__ */ React2.createElement(FontAwesomeIcon, { icon: faChevronDown }))
  );
});
var ChooseAction = observer(() => {
  const { t } = useTranslation();
  const { openDeleteModal, openMoveToFolder, downloadFile } = useDamViewModel().getDamFormViewModel();
  const Action = useMemo(() => ({
    id: "action",
    // className: styles.w_272,
    className: "border-end border-gray-select bg-select-control-background choose-an-action col-auto fs-14 minw-272px",
    placeholder: t("txt_choose_an_action"),
    options: [
      {
        label: t("txt_preview"),
        value: t("txt_preview")
      },
      {
        label: t("txt_move_to_folder"),
        value: t("txt_move_to_folder"),
        onSelect: openMoveToFolder
      },
      {
        label: t("txt_download"),
        value: t("txt_download"),
        onSelect: downloadFile
      },
      {
        label: t("txt_delete"),
        value: t("txt_delete"),
        onSelect: openDeleteModal
      }
    ]
  }));
  return /* @__PURE__ */ React2.createElement("div", { className: Action.className }, /* @__PURE__ */ React2.createElement(Dropdown, { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React2.createElement(
    Dropdown.Toggle,
    {
      as: CustomToggle,
      id: "dropdown-custom-components position-relative pe-none"
    }
  ), /* @__PURE__ */ React2.createElement(
    Dropdown.Menu,
    {
      className: `shadow-sm bg-select-control-background border border-gray-select rounded-0 rounded-bottom w-100 ${index_module_default.border_top}`
    },
    /* @__PURE__ */ React2.createElement("ul", { className: "list-unstyled ps-0 mb-0 list_menu_avatar" }, Action.options.map((value, index) => {
      return /* @__PURE__ */ React2.createElement("li", { key: index }, /* @__PURE__ */ React2.createElement(
        Dropdown.Item,
        {
          as: "p",
          className: `cursor-pointer fs-14 text-blue-0 d-block rounded-1 text-decoration-none mb-0 ${index_module_default.dropdown_item}`,
          onClick: value?.onSelect
        },
        t(value.label)
      ));
    }))
  )));
});
var ChooseAnAction_default = ChooseAction;

// src/svg/ListCheck.jsx
import React3 from "react";
var ListCheck = (props) => {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React3.createElement("g", { opacity: "0.8" }, /* @__PURE__ */ React3.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.20298 13.0155C5.20298 12.9303 5.21976 12.8459 5.25238 12.7671C5.28499 12.6884 5.3328 12.6168 5.39306 12.5566C5.45333 12.4963 5.52487 12.4485 5.60361 12.4159C5.68235 12.3833 5.76675 12.3665 5.85198 12.3665H13.299C13.4714 12.3665 13.6367 12.435 13.7586 12.5569C13.8805 12.6788 13.949 12.8441 13.949 13.0165C13.949 13.1889 13.8805 13.3542 13.7586 13.4761C13.6367 13.598 13.4714 13.6665 13.299 13.6665H5.85198C5.76658 13.6665 5.68202 13.6496 5.60315 13.6169C5.52428 13.5842 5.45265 13.5362 5.39236 13.4757C5.33206 13.4152 5.2843 13.3434 5.2518 13.2645C5.21931 13.1855 5.20271 13.1009 5.20298 13.0155ZM5.20298 7.82449C5.20298 7.65237 5.27135 7.48729 5.39306 7.36558C5.51478 7.24387 5.67985 7.17549 5.85198 7.17549H13.299C13.4714 7.17549 13.6367 7.24397 13.7586 7.36587C13.8805 7.48777 13.949 7.6531 13.949 7.82549C13.949 7.99788 13.8805 8.16321 13.7586 8.28511C13.6367 8.40701 13.4714 8.47549 13.299 8.47549H5.85198C5.76658 8.47549 5.68202 8.45864 5.60315 8.4259C5.52428 8.39316 5.45265 8.34517 5.39236 8.2847C5.33206 8.22422 5.2843 8.15244 5.2518 8.07347C5.21931 7.99449 5.20271 7.90989 5.20298 7.82449ZM5.20298 2.63349C5.20377 2.46189 5.2725 2.29758 5.39412 2.17652C5.51575 2.05545 5.68037 1.98749 5.85198 1.98749H13.299C13.4714 1.98749 13.6367 2.05597 13.7586 2.17787C13.8805 2.29977 13.949 2.4651 13.949 2.63749C13.949 2.80988 13.8805 2.97521 13.7586 3.09711C13.6367 3.21901 13.4714 3.28749 13.299 3.28749H5.85198C5.76633 3.28749 5.68152 3.27054 5.60245 3.23761C5.52339 3.20469 5.45162 3.15643 5.39129 3.09564C5.33096 3.03484 5.28326 2.96271 5.25094 2.88339C5.21862 2.80407 5.20232 2.71914 5.20298 2.63349ZM3.71598 0.876491C3.77642 0.936777 3.82437 1.0084 3.85709 1.08724C3.88981 1.16609 3.90665 1.25062 3.90665 1.33599C3.90665 1.42136 3.88981 1.50589 3.85709 1.58474C3.82437 1.66359 3.77642 1.7352 3.71598 1.79549L1.76898 3.74149C1.70869 3.80193 1.63707 3.84989 1.55822 3.88261C1.47937 3.91532 1.39484 3.93217 1.30948 3.93217C1.22411 3.93217 1.13958 3.91532 1.06073 3.88261C0.981882 3.84989 0.910263 3.80193 0.849976 3.74149L0.200976 3.09249C0.08366 2.9697 0.0190591 2.80587 0.0209947 2.63606C0.0229302 2.46624 0.0912486 2.30393 0.211333 2.18385C0.331417 2.06376 0.49373 1.99544 0.663544 1.99351C0.833358 1.99157 0.997186 2.05617 1.11998 2.17349L1.30998 2.36349L2.79798 0.875491C2.85826 0.815049 2.92988 0.767095 3.00873 0.734376C3.08758 0.701657 3.17211 0.684814 3.25748 0.684814C3.34284 0.684814 3.42737 0.701657 3.50622 0.734376C3.58507 0.767095 3.65669 0.815049 3.71698 0.875491L3.71598 0.876491ZM3.71598 6.06749C3.77642 6.12778 3.82437 6.1994 3.85709 6.27824C3.88981 6.35709 3.90665 6.44162 3.90665 6.52699C3.90665 6.61236 3.88981 6.69689 3.85709 6.77574C3.82437 6.85458 3.77642 6.9262 3.71598 6.98649L1.76898 8.93349C1.70869 8.99393 1.63707 9.04189 1.55822 9.0746C1.47937 9.10732 1.39484 9.12417 1.30948 9.12417C1.22411 9.12417 1.13958 9.10732 1.06073 9.0746C0.981882 9.04189 0.910263 8.99393 0.849976 8.93349L0.200976 8.28749C0.138356 8.22766 0.0883242 8.15592 0.0538185 8.07649C0.0193127 7.99705 0.0010293 7.91152 4.2222e-05 7.82492C-0.000944854 7.73832 0.0153842 7.6524 0.0480705 7.5722C0.0807567 7.49199 0.129141 7.41913 0.190381 7.35789C0.25162 7.29666 0.324481 7.24827 0.404682 7.21558C0.484883 7.1829 0.570808 7.16657 0.657408 7.16756C0.744009 7.16854 0.829539 7.18683 0.908974 7.22133C0.98841 7.25584 1.06015 7.30587 1.11998 7.36849L1.30998 7.55849L2.79798 6.06649C2.85826 6.00605 2.92988 5.9581 3.00873 5.92538C3.08758 5.89266 3.17211 5.87581 3.25748 5.87581C3.34284 5.87581 3.42737 5.89266 3.50622 5.92538C3.58507 5.9581 3.65669 6.00605 3.71698 6.06649L3.71598 6.06749ZM3.71598 11.2585C3.77642 11.3188 3.82437 11.3904 3.85709 11.4692C3.88981 11.5481 3.90665 11.6326 3.90665 11.718C3.90665 11.8034 3.88981 11.8879 3.85709 11.9667C3.82437 12.0456 3.77642 12.1172 3.71598 12.1775L1.76898 14.1245C1.70869 14.1849 1.63707 14.2329 1.55822 14.2656C1.47937 14.2983 1.39484 14.3152 1.30948 14.3152C1.22411 14.3152 1.13958 14.2983 1.06073 14.2656C0.981882 14.2329 0.910263 14.1849 0.849976 14.1245L0.200976 13.4755C0.138356 13.4157 0.0883242 13.3439 0.0538185 13.2645C0.0193127 13.1851 0.0010293 13.0995 4.2222e-05 13.0129C-0.000944854 12.9263 0.0153842 12.8404 0.0480705 12.7602C0.0807567 12.68 0.129141 12.6071 0.190381 12.5459C0.25162 12.4847 0.324481 12.4363 0.404682 12.4036C0.484883 12.3709 0.570808 12.3546 0.657408 12.3556C0.744009 12.3565 0.829539 12.3748 0.908974 12.4093C0.98841 12.4438 1.06015 12.4939 1.11998 12.5565L1.30898 12.7475L2.79698 11.2585C2.85726 11.198 2.92888 11.1501 3.00773 11.1174C3.08658 11.0847 3.17111 11.0678 3.25648 11.0678C3.34184 11.0678 3.42637 11.0847 3.50522 11.1174C3.58407 11.1501 3.65569 11.198 3.71598 11.2585Z"
      }
    ))
  );
};
var ListCheck_default = ListCheck;

// src/svg/ThumbNails.jsx
import React4 from "react";
var ThumbNails = (props) => {
  return /* @__PURE__ */ React4.createElement(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...props
    },
    /* @__PURE__ */ React4.createElement("g", { opacity: "0.8" }, /* @__PURE__ */ React4.createElement("path", { d: "M2.353 0H0.42C0.308609 0 0.201781 0.0442501 0.123015 0.123015C0.0442501 0.201781 0 0.308609 0 0.42V2.353C0 2.46439 0.0442501 2.57122 0.123015 2.64998C0.201781 2.72875 0.308609 2.773 0.42 2.773H2.353C2.46439 2.773 2.57122 2.72875 2.64998 2.64998C2.72875 2.57122 2.773 2.46439 2.773 2.353V0.42C2.773 0.308782 2.72889 0.202105 2.65034 0.123368C2.57179 0.0446317 2.46522 0.000264804 2.354 0H2.353Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M7.96628 0H6.03328C5.92189 0 5.81506 0.0442501 5.7363 0.123015C5.65753 0.201781 5.61328 0.308609 5.61328 0.42V2.353C5.61328 2.46439 5.65753 2.57122 5.7363 2.64998C5.81506 2.72875 5.92189 2.773 6.03328 2.773H7.96628C8.07767 2.773 8.1845 2.72875 8.26327 2.64998C8.34203 2.57122 8.38628 2.46439 8.38628 2.353V0.42C8.38628 0.308609 8.34203 0.201781 8.26327 0.123015C8.1845 0.0442501 8.07767 0 7.96628 0Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M14.0006 0.42C14.0006 0.308609 13.9564 0.201781 13.8776 0.123015C13.7988 0.0442501 13.692 0 13.5806 0H11.6446C11.5332 0 11.4264 0.0442501 11.3476 0.123015C11.2689 0.201781 11.2246 0.308609 11.2246 0.42V2.353C11.2246 2.46439 11.2689 2.57122 11.3476 2.64998C11.4264 2.72875 11.5332 2.773 11.6446 2.773H13.5776C13.6328 2.773 13.6874 2.76214 13.7383 2.74103C13.7893 2.71992 13.8356 2.68899 13.8746 2.64998C13.9136 2.61098 13.9445 2.56468 13.9656 2.51373C13.9867 2.46277 13.9976 2.40816 13.9976 2.353V0.42H14.0006Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M2.353 5.612H0.42C0.308609 5.612 0.201781 5.65625 0.123015 5.73501C0.0442501 5.81378 0 5.92061 0 6.032V7.965C0 8.07639 0.0442501 8.18322 0.123015 8.26198C0.201781 8.34075 0.308609 8.385 0.42 8.385H2.353C2.46439 8.385 2.57122 8.34075 2.64998 8.26198C2.72875 8.18322 2.773 8.07639 2.773 7.965V6.034C2.773 5.92278 2.72889 5.8161 2.65034 5.73737C2.57179 5.65863 2.46522 5.61426 2.354 5.614L2.353 5.612Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M7.96628 5.612H6.03328C5.92189 5.612 5.81506 5.65625 5.7363 5.73501C5.65753 5.81378 5.61328 5.92061 5.61328 6.032V7.965C5.61328 8.07639 5.65753 8.18322 5.7363 8.26198C5.81506 8.34075 5.92189 8.385 6.03328 8.385H7.96628C8.07767 8.385 8.1845 8.34075 8.26327 8.26198C8.34203 8.18322 8.38628 8.07639 8.38628 7.965V6.034C8.38628 5.92261 8.34203 5.81578 8.26327 5.73701C8.1845 5.65825 8.07767 5.614 7.96628 5.614V5.612Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M13.5806 5.612H11.6446C11.5332 5.612 11.4264 5.65625 11.3476 5.73501C11.2689 5.81378 11.2246 5.92061 11.2246 6.032V7.965C11.2246 8.07639 11.2689 8.18322 11.3476 8.26198C11.4264 8.34075 11.5332 8.385 11.6446 8.385H13.5776C13.6328 8.385 13.6874 8.37414 13.7383 8.35303C13.7893 8.33192 13.8356 8.30099 13.8746 8.26198C13.9136 8.22298 13.9445 8.17668 13.9656 8.12573C13.9867 8.07477 13.9976 8.02015 13.9976 7.965V6.034C13.9976 5.92278 13.9535 5.8161 13.8749 5.73737C13.7964 5.65863 13.6898 5.61426 13.5786 5.614L13.5806 5.612Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M2.353 11.227H0.42C0.308609 11.227 0.201781 11.2712 0.123015 11.35C0.0442501 11.4288 0 11.5356 0 11.647V13.58C0 13.6352 0.010864 13.6898 0.031971 13.7407C0.053078 13.7917 0.0840148 13.838 0.123015 13.877C0.162016 13.916 0.208316 13.9469 0.259273 13.968C0.31023 13.9891 0.364845 14 0.42 14H2.353C2.40816 14 2.46277 13.9891 2.51373 13.968C2.56468 13.9469 2.61098 13.916 2.64998 13.877C2.68899 13.838 2.71992 13.7917 2.74103 13.7407C2.76214 13.6898 2.773 13.6352 2.773 13.58V11.644C2.77313 11.5889 2.76239 11.5343 2.74139 11.4833C2.7204 11.4324 2.68955 11.3861 2.65063 11.3471C2.61171 11.3081 2.56548 11.2771 2.51458 11.256C2.46367 11.2349 2.40911 11.224 2.354 11.224L2.353 11.227Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M7.96628 11.227H6.03328C5.92189 11.227 5.81506 11.2712 5.7363 11.35C5.65753 11.4288 5.61328 11.5356 5.61328 11.647V13.58C5.61328 13.6352 5.62415 13.6898 5.64525 13.7407C5.66636 13.7917 5.6973 13.838 5.7363 13.877C5.7753 13.916 5.8216 13.9469 5.87255 13.968C5.92351 13.9891 5.97813 14 6.03328 14H7.96628C8.02144 14 8.07605 13.9891 8.12701 13.968C8.17797 13.9469 8.22427 13.916 8.26327 13.877C8.30227 13.838 8.3332 13.7917 8.35431 13.7407C8.37542 13.6898 8.38628 13.6352 8.38628 13.58V11.644C8.38628 11.5326 8.34203 11.4258 8.26327 11.347C8.1845 11.2682 8.07767 11.224 7.96628 11.224V11.227Z" }), /* @__PURE__ */ React4.createElement("path", { d: "M13.5806 11.227H11.6446C11.5332 11.227 11.4264 11.2712 11.3476 11.35C11.2689 11.4288 11.2246 11.5356 11.2246 11.647V13.58C11.2246 13.6352 11.2355 13.6898 11.2566 13.7407C11.2777 13.7917 11.3086 13.838 11.3476 13.877C11.3866 13.916 11.4329 13.9469 11.4839 13.968C11.5348 13.9891 11.5895 14 11.6446 14H13.5776C13.6328 14 13.6874 13.9891 13.7383 13.968C13.7893 13.9469 13.8356 13.916 13.8746 13.877C13.9136 13.838 13.9445 13.7917 13.9656 13.7407C13.9867 13.6898 13.9976 13.6352 13.9976 13.58V11.644C13.9977 11.5889 13.987 11.5343 13.966 11.4833C13.945 11.4324 13.9142 11.3861 13.8752 11.3471C13.8363 11.3081 13.7901 11.2771 13.7392 11.256C13.6883 11.2349 13.6337 11.224 13.5786 11.224L13.5806 11.227Z" }))
  );
};
var ThumbNails_default = ThumbNails;

// src/components/Table/index.jsx
import { AesirXSelect, PAGE_STATUS, Spinner, history } from "aesirx-uikit";

// src/components/Table/Thumb.jsx
import React5, { useEffect, useState } from "react";
import { getEmptyImage } from "react-dnd-html5-backend";
import { useDrag, useDrop } from "react-dnd";
import { DAM_ASSETS_FIELD_KEY } from "aesirx-lib";
import { observer as observer2 } from "mobx-react";
import { useTranslation as useTranslation2 } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
var DND_ITEM_TYPE = "thumb";
var timer = 0;
var delay = 200;
var prevent = false;
var FakeThumb = observer2(({ id, index, isList, dataLength }) => {
  const {
    damListViewModel: {
      actionState: { selectedCards = [] }
    }
  } = useDamViewModel();
  const isSelect = selectedCards.map((selectedCard) => +selectedCard.id).includes(+id);
  const checkBorderBottom = selectedCards.map((selectedCard) => +selectedCard.index).includes(+index + 1);
  const checkBorderTop = selectedCards.map((selectedCard) => +selectedCard.index).includes(+index - 1);
  const isChecked = isSelect | dataLength === selectedCards.length ? true : false;
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(
    "span",
    {
      className: `position-absolute top-0 start-0 zindex-2 w-100 h-100 user-select-none ${isSelect ? "border border-2 border-select-item" : ""} ${checkBorderBottom && isList ? "border-bottom-0" : ""} ${checkBorderTop && isList ? "border-top-0" : ""} ${isList && isSelect ? " border-start-0 border-end-0 " : ""} ${table_module_default.item_hover}`,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }
  ), !isList && (isSelect || isHovered) && /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: `${table_module_default.checkbox} position-absolute top-0 icon-check zindex-1 border border-success end-0 m-2 text-success`
    },
    /* @__PURE__ */ React5.createElement(
      "input",
      {
        className: "form-check-input zindex-5 p-1 w-100 h-100 bg-transparent",
        checked: isChecked,
        onChange: () => {
        },
        type: "checkbox"
      }
    )
  ));
});
var IndeterminateCheckbox = observer2(({ index, dataLength }) => {
  const {
    damListViewModel: {
      actionState: { selectedCards = [] }
    }
  } = useDamViewModel();
  const selectedIndex = selectedCards.map((selectedCard) => +selectedCard.index).includes(+index);
  const isChecked = selectedIndex | dataLength === selectedCards.length ? true : false;
  return isChecked && /* @__PURE__ */ React5.createElement("div", { className: table_module_default.checkbox }, /* @__PURE__ */ React5.createElement(
    "input",
    {
      className: "form-check-input p-0 w-100 h-100 bg-transparent",
      checked: isChecked,
      onChange: () => {
      },
      type: "checkbox"
    }
  ));
});
var ThumbContainer = React5.memo(({ newRowCells }) => {
  return newRowCells.map((cell) => /* @__PURE__ */ React5.createElement(
    "div",
    {
      ...cell.getCellProps(),
      className: `ct_cell d-block w-100 user-select-none`,
      key: Math.random(40, 200)
    },
    cell.render("Cell")
  ));
});
var Thumb = observer2(
  ({
    row,
    className,
    newRowCells,
    index,
    moveRow,
    onDoubleClick,
    onRightClickItem,
    isList = false,
    type,
    onSelectionChange
  }) => {
    const ref = React5.useRef(null);
    const {
      damListViewModel: {
        actionState: { selectedCards }
      },
      damFormViewModel: { isEditCollection }
    } = useDamViewModel();
    const [{ isOver }, drop] = useDrop({
      accept: DND_ITEM_TYPE,
      drop: (item) => {
        if (!ref.current) {
          return;
        }
        const dragIndex = item.items;
        const hoverIndex = +row.original.id;
        if (dragIndex.map((dragItem) => +dragItem.id).includes(hoverIndex)) {
          return;
        }
        if (row.original?.[DAM_ASSETS_FIELD_KEY.TYPE]) {
          return;
        }
        moveRow(dragIndex, hoverIndex);
      },
      collect: (monitor) => {
        if (monitor.getItem()?.items) {
          if (monitor.getItem()?.dataTransfer) {
            return {
              isOver: monitor.isOver()
            };
          } else {
            const checkItemSelect = monitor.getItem()?.items?.map((item) => +item.id) ?? [];
            if (checkItemSelect.includes(+row?.original.id) || row.original?.[DAM_ASSETS_FIELD_KEY.TYPE]) {
              return false;
            } else {
              return {
                isOver: monitor.isOver()
              };
            }
          }
        } else {
          return false;
        }
      }
    });
    const [{ opacity }, drag, preview] = useDrag({
      type: DND_ITEM_TYPE,
      item: () => {
        const { id } = row.original;
        const draggedCard = row.original;
        let cards = [];
        if (selectedCards.find((card) => +card.id === +id)) {
          cards = selectedCards;
        } else {
          cards = [draggedCard];
        }
        const cardsIDs = cards;
        return { items: cardsIDs };
      },
      isDragging: (monitor) => {
        return monitor.getItem().items.map((item) => +item.id).includes(+row.original.id);
      },
      canDrag: () => {
        return isEditCollection ? false : true;
      },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1
      })
    });
    const onSelect = () => {
      onSelectionChange(index, true, false, false);
    };
    useEffect(() => {
      preview(getEmptyImage(), {
        // IE fallback: specify that we'd rather screenshot the node
        // when it already knows it's being dragged so we can hide it with CSS.
        captureDraggingState: true
      });
    }, []);
    drag(drop(ref));
    const { t } = useTranslation2();
    const tooltip = /* @__PURE__ */ React5.createElement(Tooltip, { id: `tooltip-${row.original.id}` }, /* @__PURE__ */ React5.createElement("p", { className: "mb-0 fs-12" }, t("double_click_to_edit")), /* @__PURE__ */ React5.createElement("p", { className: "mb-0 fs-12" }, t("right-click_to_get_a_list_of_actions")));
    return isList ? /* @__PURE__ */ React5.createElement(OverlayTrigger, { placement: "top", overlay: tooltip }, /* @__PURE__ */ React5.createElement(
      "tr",
      {
        key: row.getRowProps().key,
        ...row.getRowProps(),
        className: `position-relative item_thumb cursor-move ${isOver ? "border border-success bg-success-05" : "border-none"} ${className}`,
        onDoubleClick: () => {
          clearTimeout(timer);
          prevent = true;
          onDoubleClick(row.original);
        },
        onClick: (e) => {
          timer = setTimeout(function() {
            if (!prevent) {
              onSelect(e);
            }
            prevent = false;
          }, delay);
        },
        onContextMenu: (e) => {
          onRightClickItem(e, { ...row.original, index });
        },
        style: { opacity },
        type,
        ref
      },
      newRowCells.map((cell, _index) => {
        if (cell.column.id === "selection") {
          return /* @__PURE__ */ React5.createElement("td", { key: _index, ...cell.getCellProps(), style: { width: 64 } }, /* @__PURE__ */ React5.createElement(IndeterminateCheckbox, { index }));
        } else {
          return /* @__PURE__ */ React5.createElement("td", { key: _index, ...cell.getCellProps(), className: "fw-normal px-2 py-3" }, cell.render("Cell"), /* @__PURE__ */ React5.createElement(FakeThumb, { id: +row.original.id, index, isList: true }));
        }
      })
    )) : /* @__PURE__ */ React5.createElement(OverlayTrigger, { placement: "top", overlay: tooltip }, /* @__PURE__ */ React5.createElement("div", { style: { opacity }, className }, /* @__PURE__ */ React5.createElement(
      "div",
      {
        className: `${isOver ? "border-success bg-success-05" : "bg-white border-thumb"} position-relative item_thumb d-flex border-1  cursor-move align-items-center justify-content-center shadow-sm h-100 rounded-2 overflow-hidden flex-column `,
        onContextMenu: (e) => {
          onRightClickItem(e, { ...row.original, index });
        },
        ref,
        onDoubleClick: () => {
          clearTimeout(timer);
          prevent = true;
          if (!isEditCollection) {
            onDoubleClick(row.original);
          }
        },
        onClick: (e) => {
          timer = setTimeout(function() {
            if (!prevent) {
              onSelect(e);
            }
            prevent = false;
          }, delay);
        },
        type
      },
      /* @__PURE__ */ React5.createElement(ThumbContainer, { newRowCells }),
      /* @__PURE__ */ React5.createElement(FakeThumb, { id: +row.original.id })
    )));
  }
);
var Thumb_default = Thumb;

// src/svg/ArrowBack.jsx
import React6 from "react";
var ArrowBack = ({ fill = "none", ...props }) => {
  return /* @__PURE__ */ React6.createElement(
    "svg",
    {
      ...props,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React6.createElement(
      "path",
      {
        d: "M19 11.0003H7.14L10.77 6.64028C10.9397 6.43606 11.0214 6.17278 10.997 5.90835C10.9726 5.64393 10.8442 5.40001 10.64 5.23028C10.4358 5.06054 10.1725 4.97888 9.90808 5.00325C9.64365 5.02763 9.39974 5.15606 9.23 5.36028L4.23 11.3603C4.19636 11.408 4.16628 11.4581 4.14 11.5103C4.14 11.5603 4.14 11.5903 4.07 11.6403C4.02467 11.7549 4.00094 11.877 4 12.0003C4.00094 12.1236 4.02467 12.2456 4.07 12.3603C4.07 12.4103 4.07 12.4403 4.14 12.4903C4.16628 12.5424 4.19636 12.5926 4.23 12.6403L9.23 18.6403C9.32402 18.7532 9.44176 18.8439 9.57485 18.9062C9.70793 18.9684 9.85309 19.0005 10 19.0003C10.2337 19.0007 10.4601 18.9194 10.64 18.7703C10.7413 18.6863 10.825 18.5832 10.8863 18.4669C10.9477 18.3505 10.9855 18.2232 10.9975 18.0922C11.0096 17.9613 10.9957 17.8292 10.9567 17.7036C10.9176 17.578 10.8542 17.4613 10.77 17.3603L7.14 13.0003H19C19.2652 13.0003 19.5196 12.8949 19.7071 12.7074C19.8946 12.5198 20 12.2655 20 12.0003C20 11.7351 19.8946 11.4807 19.7071 11.2932C19.5196 11.1056 19.2652 11.0003 19 11.0003Z",
        fill: "#1A2226"
      }
    )
  );
};
var ArrowBack_default = ArrowBack;

// src/components/Table/ThumbDragLayer.jsx
import React8 from "react";
import { useDragLayer } from "react-dnd";

// src/components/Table/ThumbDragPreview.jsx
import React7 from "react";
import { Image } from "aesirx-uikit";
import { DAM_ASSETS_FIELD_KEY as DAM_ASSETS_FIELD_KEY2 } from "aesirx-lib";
var ThumbsDragPreview = ({ thumbs }) => {
  return /* @__PURE__ */ React7.createElement("div", null, thumbs.length ? thumbs.slice(0, 3).map((thumb, i) => /* @__PURE__ */ React7.createElement(
    "div",
    {
      key: thumb.id,
      className: "d-flex align-items-center",
      style: {
        zIndex: thumbs.length - i,
        transform: `rotateZ(${-i * 2.5}deg)`
      }
    },
    /* @__PURE__ */ React7.createElement(
      Image,
      {
        alt: thumb.name,
        src: thumb?.[DAM_ASSETS_FIELD_KEY2.TYPE] ? thumb?.[DAM_ASSETS_FIELD_KEY2.DOWNLOAD_URL] : "/assets/images/folder.svg",
        wrapperClassName: table_module_default.image_thumb
      }
    ),
    /* @__PURE__ */ React7.createElement("span", { className: "ps-1" }, " ", thumb.name)
  )) : /* @__PURE__ */ React7.createElement("div", { className: "" }, "File"));
};
var ThumbDragPreview_default = ThumbsDragPreview;

// src/components/Table/ThumbDragLayer.jsx
var layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  right: 0,
  bottom: 0
};
var getItemStyles = (currentOffset) => {
  if (!currentOffset) {
    return {
      display: "none"
    };
  }
  const { x, y } = currentOffset;
  return {
    transform: `translate(${x}px, ${y}px)`,
    filter: "drop-shadow(0 2px 5px rgba(0,0,0,0.45))"
  };
};
function ThumbDragLayer() {
  const { itemType, isDragging, item, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }));
  const renderItem = (type, item2) => {
    switch (type) {
      case DND_ITEM_TYPE:
        return /* @__PURE__ */ React8.createElement(ThumbDragPreview_default, { thumbs: item2?.items ?? [] });
      default:
        return null;
    }
  };
  if (!isDragging) {
    return null;
  }
  return /* @__PURE__ */ React8.createElement("div", { style: layerStyles }, /* @__PURE__ */ React8.createElement("div", { style: getItemStyles(currentOffset) }, renderItem(itemType, item)));
}

// src/components/Table/index.jsx
var Table = ({
  rowData = [],
  tableRowHeader = [],
  // onSelect,
  dataList,
  dataThumb,
  thumbColumnsNumber,
  isList = false,
  listViewModel,
  _handleList,
  classNameTable,
  onDoubleClick,
  createAssets,
  onFilter,
  onSortby,
  onRightClickItem,
  onBackClick,
  dataCollections,
  onSelectionChange,
  toolbar = true
}) => {
  const { t } = useTranslation3();
  const columns = useMemo2(() => tableRowHeader, [tableRowHeader]);
  const data = useMemo2(() => rowData, [rowData]);
  const filterBar = useMemo2(() => ({
    id: "type",
    className: "border-end border-gray-select col-auto fs-14 text-blue-0",
    placeholder: t("txt_type"),
    options: [
      {
        label: t("txt_type"),
        value: ""
      },
      {
        label: t("txt_image"),
        value: "image"
      },
      {
        label: t("txt_video"),
        value: "video"
      },
      {
        label: t("txt_document"),
        value: "document"
      },
      {
        label: t("txt_audio"),
        value: "audio"
      }
    ]
  }));
  const sortBy = useMemo2(() => ({
    id: "sort_by",
    placeholder: t("txt_sort_by"),
    className: "border-end border-gray-select col-auto fs-14 text-blue-0",
    options: [
      {
        label: t("txt_sort_by"),
        value: {
          ordering: "",
          direction: ""
        }
      },
      {
        label: t("txt_date_create"),
        value: {
          ordering: DAM_ASSETS_FIELD_KEY3.CREATE_DATE,
          direction: "desc"
        }
      },
      {
        label: t("txt_last_modified"),
        value: {
          ordering: DAM_ASSETS_FIELD_KEY3.LAST_MODIFIED,
          direction: "desc"
        }
      },
      {
        label: t("txt_a_z"),
        value: {
          ordering: DAM_ASSETS_FIELD_KEY3.NAME,
          direction: "asc"
        }
      },
      {
        label: t("txt_z_a"),
        value: {
          ordering: DAM_ASSETS_FIELD_KEY3.NAME,
          direction: "desc"
        }
      }
    ]
  }));
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable({
    columns,
    data
  });
  const moveRow = (dragIndex, hoverIndex) => {
    listViewModel.moveToFolder(dragIndex, hoverIndex);
  };
  const mainElement = document.getElementsByClassName("main-content")[0];
  const handleScroll = () => {
    if (mainElement.scrollHeight - mainElement.scrollTop - mainElement.clientHeight < 300 && listViewModel.status !== PAGE_STATUS.LOADING) {
      const limitStart = listViewModel.dataFilter["list[limit]"] + listViewModel.dataFilter["list[start]"];
      if (limitStart < listViewModel.totalAsset) {
        const collectionId = history.location.pathname.split("/");
        const currentCollection = !isNaN(collectionId[collectionId.length - 1]) ? collectionId[collectionId.length - 1] : 0;
        listViewModel.goToFolder(currentCollection, { "list[start]": limitStart }, true);
      }
    }
  };
  useEffect2(() => {
    mainElement.addEventListener("scroll", handleScroll);
    return () => mainElement.removeEventListener("scroll", handleScroll);
  }, []);
  return /* @__PURE__ */ React9.createElement(DndProvider, { backend: HTML5Backend }, /* @__PURE__ */ React9.createElement("div", { className: `mb-4 zindex-3 ${classNameTable}` }, /* @__PURE__ */ React9.createElement("div", { className: "bg-blue-5 shadow-sm rounded-3 d-flex align-items-center justify-content-between" }, /* @__PURE__ */ React9.createElement("div", { className: "wrapper_search_global d-flex" }, toolbar && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(
    AesirXSelect,
    {
      className: filterBar.className,
      isShadow: true,
      isClearable: false,
      isSearchable: false,
      options: filterBar.options,
      onChange: onFilter,
      isBackGround: true,
      value: filterBar.options.find(
        (e) => e.value === listViewModel.dataFilter["filter[type]"]
      )
    }
  ), /* @__PURE__ */ React9.createElement(ChooseAnAction_default, null)), /* @__PURE__ */ React9.createElement(
    AesirXSelect,
    {
      className: sortBy.className,
      isShadow: true,
      isClearable: false,
      isSearchable: false,
      options: sortBy.options,
      isBackGround: true,
      onChange: onSortby,
      value: sortBy.options.find(
        (e) => e.value.ordering === listViewModel.dataFilter["list[ordering]"] && e.value.direction === listViewModel.dataFilter["list[direction]"]
      )
    }
  )), /* @__PURE__ */ React9.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ React9.createElement(
    "button",
    {
      type: "button",
      className: `btn d-flex align-items-center fw-bold rounded-0 px-4 shadow-none ${isList ? "bg-blue-3 text-white  border-0  border-gray-select" : "text-blue-6"}`,
      onClick: () => _handleList("list")
    },
    /* @__PURE__ */ React9.createElement(ListCheck_default, null),
    /* @__PURE__ */ React9.createElement("span", { className: "ms-2 fw-medium fs-14" }, t("txt_list"))
  ), /* @__PURE__ */ React9.createElement(
    "button",
    {
      type: "button",
      className: `btn rounded-end d-flex align-items-center fw-bold rounded-0 px-4 shadow-none ${!isList ? "bg-blue-3 text-white border-0 border-gray-select" : "text-blue-6"}`,
      onClick: () => _handleList("thumb")
    },
    /* @__PURE__ */ React9.createElement(ThumbNails_default, null),
    /* @__PURE__ */ React9.createElement("span", { className: "ms-2 fw-medium fs-14" }, t("txt_thumb"))
  )))), listViewModel.status === PAGE_STATUS.LOADING ? /* @__PURE__ */ React9.createElement(Spinner, null) : /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(ThumbDragLayer, null), isList ? /* @__PURE__ */ React9.createElement("div", { className: "py-3 rounded-3 col" }, rows.length ? /* @__PURE__ */ React9.createElement("table", { ...getTableProps(), className: `w-100 bg-white mb-4 ${classNameTable}` }, /* @__PURE__ */ React9.createElement("thead", null, headerGroups.map((headerGroup) => {
    let newHeaderGroup = "";
    dataList ? newHeaderGroup = headerGroup.headers.filter(
      (item) => !dataList.some((other) => item.id === other)
    ) : newHeaderGroup = headerGroup.headers;
    return /* @__PURE__ */ React9.createElement(
      "tr",
      {
        key: Math.random(40, 200),
        ...headerGroup.getHeaderGroupProps(),
        className: " position-relative bg-white border-bottom border-gray-500 zindex-2"
      },
      newHeaderGroup.map((column, index) => {
        if (column?.id === "selection") {
          return /* @__PURE__ */ React9.createElement(
            "th",
            {
              key: index,
              ...column.getHeaderProps(),
              className: "fw-normal px-2 py-3 flex-1 bg-white",
              style: { width: 64 }
            }
          );
        } else {
          return /* @__PURE__ */ React9.createElement(
            "th",
            {
              key: index,
              ...column.getHeaderProps(),
              className: "fw-normal px-2 py-3 flex-1 bg-white text-capitalize"
            },
            column.render("Header")
          );
        }
      })
    );
  })), /* @__PURE__ */ React9.createElement("tbody", { ...getTableBodyProps() }, rows.length > 0 && rows.map((row, index) => {
    prepareRow(row);
    let newRowCells = "";
    dataList ? newRowCells = row.cells.filter(
      (item) => !dataList.some((other) => item.column.id === other)
    ) : newRowCells = row.cells;
    return /* @__PURE__ */ React9.createElement(
      Thumb_default,
      {
        ...row.getRowProps(),
        isList: true,
        className: `zindex-2 ${index % 2 === 0 ? "bg-body" : "bg-white"}`,
        key: Math.random(40, 200),
        newRowCells,
        index,
        row,
        onDoubleClick,
        onRightClickItem,
        moveRow,
        type: row.original[DAM_ASSETS_FIELD_KEY3.TYPE] ? "assets" : "folder",
        onSelectionChange
      }
    );
  }))) : null) : /* @__PURE__ */ React9.createElement("div", { ...getTableBodyProps(), className: `row ${rows.length === 0 ? "col" : ""}` }, rows.length ? rows.map((row, index) => {
    prepareRow(row);
    let newRowCells = row.cells;
    if (dataThumb && dataThumb.length > 0) {
      newRowCells = row.cells.filter(
        (item) => !dataThumb.some((other) => item.column.id === other)
      );
    }
    return newRowCells.length > 0 && /* @__PURE__ */ React9.createElement(React9.Fragment, { key: row?.original?.id }, index === 0 && !row.original[DAM_ASSETS_FIELD_KEY3.TYPE] && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement("div", { className: "col-12" }, /* @__PURE__ */ React9.createElement("p", { className: "fw-bold text-body" }, t("txt_folders"))), listViewModel?.damLinkFolder.split("/").length > 1 && /* @__PURE__ */ React9.createElement(
      "div",
      {
        className: `col_thumb ${table_module_default.col_thumb_folder} col-${!thumbColumnsNumber ? "3" : thumbColumnsNumber} mb-4 zindex-2`
      },
      /* @__PURE__ */ React9.createElement(
        "div",
        {
          className: `item_thumb d-flex cursor-pointer align-items-center justify-content-center  shadow-sm h-100 rounded-2 overflow-hidden flex-column bg-white
                      `,
          onClick: onBackClick
        },
        /* @__PURE__ */ React9.createElement(ArrowBack_default, null),
        /* @__PURE__ */ React9.createElement("span", null, t("txt_back"))
      )
    )), dataCollections.length === index && row.original[DAM_ASSETS_FIELD_KEY3.TYPE] && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement("div", { className: "col-12" }, /* @__PURE__ */ React9.createElement("p", { className: "fw-bold text-body" }, t("txt_file"))), index === 0 && listViewModel?.damLinkFolder.split("/").length > 1 && /* @__PURE__ */ React9.createElement(
      "div",
      {
        className: `col_thumb ${table_module_default.col_thumb_folder} col-${!thumbColumnsNumber ? "3" : thumbColumnsNumber} mb-4 zindex-2`
      },
      /* @__PURE__ */ React9.createElement(
        "div",
        {
          className: `item_thumb d-flex cursor-pointer align-items-center justify-content-center  shadow-sm h-100 rounded-2 overflow-hidden flex-column bg-white
              `,
          onClick: onBackClick
        },
        /* @__PURE__ */ React9.createElement(ArrowBack_default, null),
        /* @__PURE__ */ React9.createElement("span", null, t("txt_back"))
      )
    )), /* @__PURE__ */ React9.createElement(
      Thumb_default,
      {
        ...row.getRowProps(),
        className: `col_thumb  ${!isList && !row.original[DAM_ASSETS_FIELD_KEY3.TYPE] ? table_module_default.col_thumb_folder : table_module_default.col_thumb}  col-${!thumbColumnsNumber ? "3" : thumbColumnsNumber} mb-4 zindex-2`,
        newRowCells,
        index,
        row,
        onDoubleClick,
        onRightClickItem,
        moveRow,
        type: row.original[DAM_ASSETS_FIELD_KEY3.TYPE] ? "assets" : "folder",
        onSelectionChange
      }
    ));
  }) : null), rows.length === 0 ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(
    "p",
    {
      onClick: onBackClick,
      className: "d-flex zindex-2 align-items-center cursor-pointer"
    },
    listViewModel?.damLinkFolder.split("/").length > 1 && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(ArrowBack_default, null), " ", /* @__PURE__ */ React9.createElement("span", { className: "fw-semibold ps-2" }, t("txt_back")))
  ), /* @__PURE__ */ React9.createElement(
    ComponentNoData_default,
    {
      icons: "/assets/images/ic_project.svg",
      title: "No Matching Results",
      text: "Can not found any project with that keyword. Please try another keyword.",
      width: "w-50",
      createAssets
    }
  )) : /* @__PURE__ */ React9.createElement(Dropzone_default, { isBtn: false, noDrag: false, createAssets, noClick: true })));
};
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}
filterGreaterThan.autoRemove = (val) => typeof val !== "number";
var Table_default = withTranslation2()(Table);

// src/constants/DamConstant.js
var DAM_COLUMN_INDICATOR = {
  ID: "id",
  NAME: "name",
  FILE_SIZE: "file_size",
  OWNER: "owner",
  LAST_MODIFIED: "modified_date"
};

// src/integration/lib/AesirXDamComponent.jsx
import moment from "moment";

// src/containers/Homepage/HomeForm/CollectionName.jsx
import React10, { useCallback, useState as useState2 } from "react";
import { observer as observer3 } from "mobx-react";
import { DAM_COLLECTION_FIELD_KEY } from "aesirx-lib";
import { Form } from "react-bootstrap";

// esbuild-scss-modules-plugin:../index.module.scss
var digest2 = "eda4979e9badfba4d9e9210b83d92fe179617f58b07365b4588123efc211a088";
var classes2 = { "item_collap_fixed": "_item_collap_fixed_1r1lr_5", "wrapper_new_schedule": "_wrapper_new_schedule_1r1lr_9", "full_calender": "_full_calender_1r1lr_14", "pe-400": "_pe-400_1r1lr_14", "pe400": "_pe-400_1r1lr_14", "sdbar_right": "_sdbar_right_1r1lr_17", "folder": "_folder_1r1lr_21", "image": "_image_1r1lr_25", "image_isList": "_image_isList_1r1lr_31", "popupImageHeight": "_popupImageHeight_1r1lr_36", "txt_hover": "_txt_hover_1r1lr_40", "input": "_input_1r1lr_50", "checkbox": "_checkbox_1r1lr_70", "contextMenuItem": "_contextMenuItem_1r1lr_80", "items_file": "_items_file_1r1lr_91" };
var css2 = `/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
._item_collap_fixed_1r1lr_5 {
  left: 250px;
}

._wrapper_new_schedule_1r1lr_9 {
  top: 10px;
  right: 1.5rem;
}

._full_calender_1r1lr_14 ._pe-400_1r1lr_14 {
  padding-right: 1rem !important;
}
._full_calender_1r1lr_14 ._sdbar_right_1r1lr_17 {
  display: none;
}

._folder_1r1lr_21 {
  margin-bottom: 32px;
}

._image_1r1lr_25 {
  height: 212px;
  overflow: hidden;
  width: 100%;
}

._image_isList_1r1lr_31 {
  width: 56px;
  height: 56px;
}

._popupImageHeight_1r1lr_36 {
  height: calc(100% - 50px);
}

._txt_hover_1r1lr_40:hover span {
  color: var(--bs-success);
}
._txt_hover_1r1lr_40:hover svg {
  fill: var(--bs-success);
}
._txt_hover_1r1lr_40:hover svg path {
  fill: var(--bs-success);
}

._input_1r1lr_50 {
  border: 2px solid transparent;
}
._input_1r1lr_50::-moz-selection {
  /* Code for Firefox */
  color: var(--bs-white);
  background: var(--bs-green);
  transition: 0.3s all ease-in-out;
}
._input_1r1lr_50::selection {
  color: var(--bs-white);
  background: var(--bs-green);
  transition: 0.3s all ease-in-out;
}
._input_1r1lr_50:focus {
  transition: 0.3s all ease-in-out;
  border-radius: 3px;
  box-shadow: unset;
}

._checkbox_1r1lr_70 {
  width: 16px;
  height: 16px;
  margin: 0 auto;
}
._checkbox_1r1lr_70 input {
  width: 100%;
  height: 100%;
}

._contextMenuItem_1r1lr_80 {
  min-width: 248px;
}
._contextMenuItem_1r1lr_80 div:not(:last-child):hover span {
  font-weight: 600;
  color: var(--aesirxui-green) !important;
}
._contextMenuItem_1r1lr_80 div:last-child:hover span {
  font-weight: 600;
}

._items_file_1r1lr_91 {
  display: flex !important;
}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest2)) {
    var ele = document.createElement("style");
    ele.id = digest2;
    ele.textContent = css2;
    document.head.appendChild(ele);
  }
})();
var index_module_default2 = classes2;

// src/containers/Homepage/HomeForm/CollectionName.jsx
import { notify } from "aesirx-uikit";
import { useTranslation as useTranslation4 } from "react-i18next";
var CollectionName = observer3(({ item }) => {
  const { damListViewModel, damFormViewModel } = useDamViewModel();
  const [value, setValue] = useState2(item[DAM_COLUMN_INDICATOR.NAME]);
  const [isFocus, setIsFocus] = useState2(false);
  const { t } = useTranslation4();
  const handleUpdateFolder = useCallback(() => {
    if (value) {
      if (item?.create) {
        damListViewModel.createCollections(
          {
            ...item,
            [DAM_COLLECTION_FIELD_KEY.NAME]: value
          },
          "server"
        );
      } else {
        if (value !== item[DAM_COLUMN_INDICATOR.NAME]) {
          damListViewModel.updateCollections({
            ...item,
            [DAM_COLLECTION_FIELD_KEY.NAME]: value
          });
        } else {
          setValue(item[DAM_COLUMN_INDICATOR.NAME]);
        }
      }
    } else {
      notify(t("txt_name_can_not_blank"), "warn");
    }
    damFormViewModel.setOffEditCollection();
  }, [value]);
  return /* @__PURE__ */ React10.createElement(
    Form.Control,
    {
      as: "input",
      type: "text",
      className: `mw-80 text-body border-0 ps-2 form-control-dam  fw-medium ${!damListViewModel.isList ? "text-center mx-auto fs-6" : "fs-14 "}px-0 py-1 w-fit ${isFocus ? "pe-auto border-1 border-thumb-name" : "pe-none"} ${index_module_default2.input}`,
      id: `id_${item[DAM_COLUMN_INDICATOR.ID]}`,
      value,
      onChange: (e) => setValue(e.target.value),
      onFocus: (e) => {
        e.target.select();
        setIsFocus(true);
      },
      onBlur: () => {
        if (isFocus) {
          handleUpdateFolder();
          setIsFocus(false);
        }
      },
      onKeyDown: (e) => {
        if (e.keyCode === 13) {
          e.target.blur();
        }
      }
    }
  );
});
var CollectionName_default = CollectionName;

// src/integration/lib/AesirXDamComponent.jsx
import { Button } from "react-bootstrap";
var AesirXDamComponent = observer4(
  class AesirXDamComponent2 extends Component2 {
    constructor(props) {
      super(props);
      __publicField(this, "damListViewModel", null);
      __publicField(this, "damformModalViewModal", null);
      __publicField(this, "type", "");
      __publicField(this, "toolbar", true);
      __publicField(this, "isMulti", false);
      __publicField(this, "handleClickOutside", (e) => {
        const checkContextMenu = e.target.closest("#contextMenu");
        const checkContextMenuItem = e.target.closest("#contextMenuItem");
        const checkContextItemMoveToFolder = e.target.closest("#contextMenuItemMoveToFolder");
        if (checkContextMenu || checkContextMenuItem || checkContextItemMoveToFolder) {
          return;
        } else {
          this.damFormModalViewModal.closeContextMenu();
          this.damFormModalViewModal.closeContextMenuItem();
        }
      });
      __publicField(this, "handleSelect", (data) => {
        this.damListViewModel.damIdsSelected = data.map((item) => {
          return item[this.key];
        }).reduce((arr, el) => {
          return arr.concat(el);
        }, []);
      });
      __publicField(this, "handleCreateAssets", (data) => {
        if (data) {
          const collectionId = this.damListViewModel.damLinkFolder.split("/");
          const currentCollection = !isNaN(collectionId[collectionId.length - 1]) ? collectionId[collectionId.length - 1] : 0;
          this.damListViewModel.createAssets({
            [DAM_ASSETS_API_FIELD_KEY.NAME]: data?.name ?? "",
            [DAM_ASSETS_API_FIELD_KEY.FILE_NAME]: data?.name ?? "",
            [DAM_ASSETS_API_FIELD_KEY.COLLECTION_ID]: currentCollection,
            [DAM_ASSETS_API_FIELD_KEY.FILE]: data
          });
        }
      });
      __publicField(this, "_handleList", () => {
        this.damListViewModel.isList = !this.damListViewModel.isList;
      });
      __publicField(this, "handleDoubleClick", (collection) => {
        if (!collection?.[DAM_ASSETS_FIELD_KEY4.TYPE]) {
          this.damListViewModel.setDamLinkFolder(
            this.damListViewModel.damLinkFolder + "/" + collection.id
          );
        } else {
          this.damFormModalViewModal.damEditdata = {
            ...collection
          };
          this.damFormModalViewModal.openModal();
        }
      });
      __publicField(this, "handleRightClick", (e) => {
        e.preventDefault();
        const inside = e.target.closest(".item_thumb");
        if (!inside) {
          this.damFormModalViewModal.closeContextMenuItem();
          this.damListViewModel.setActionState({
            selectedCards: []
          });
          const innerHeight = window.innerHeight;
          const innerWidth = window.innerWidth;
          let style = {
            transition: "none",
            top: e.clientY,
            left: e.clientX
          };
          if (e.clientX + 200 > innerWidth) {
            style = {
              ...style,
              right: innerWidth - e.clientX,
              left: "unset"
            };
          }
          if (e.clientY + 260 > innerHeight) {
            style = {
              ...style,
              bottom: innerHeight - e.clientY,
              top: "unset"
            };
          }
          this.damListViewModel.setActionState({
            style
          });
          this.damFormModalViewModal.openContextMenu();
        }
      });
      __publicField(this, "handleRightClickItem", (e, data) => {
        e.preventDefault();
        this.damFormModalViewModal.closeContextMenu();
        const innerHeight = window.innerHeight;
        const innerWidth = window.innerWidth;
        let style = {
          transition: "none",
          top: e.clientY,
          left: e.clientX
        };
        if (e.clientX + 200 > innerWidth) {
          style = {
            ...style,
            right: innerWidth - e.clientX,
            left: "unset"
          };
        }
        if (e.clientY + 260 > innerHeight) {
          style = {
            ...style,
            bottom: innerHeight - e.clientY,
            top: "unset"
          };
        }
        this.damFormModalViewModal.damEditdata = {
          ...data,
          style: { ...style }
        };
        this.damListViewModel.setActionState({
          style
        });
        this.damFormModalViewModal.openContextMenuItem();
      });
      __publicField(this, "handleFilter", (data) => {
        const collectionId = this.damListViewModel.damLinkFolder.split("/");
        const currentCollection = !isNaN(collectionId[collectionId.length - 1]) ? collectionId[collectionId.length - 1] : 0;
        this.damListViewModel.onFilter(currentCollection, {
          "filter[type]": data.value
        });
      });
      __publicField(this, "handleSortBy", (data) => {
        const collectionId = this.damListViewModel.damLinkFolder.split("/");
        const currentCollection = !isNaN(collectionId[collectionId.length - 1]) ? collectionId[collectionId.length - 1] : 0;
        this.damListViewModel.onFilter(
          currentCollection,
          {
            "list[ordering]": data.value.ordering,
            "list[direction]": data.value.direction
          },
          true
        );
      });
      __publicField(this, "handleBack", () => {
        const currentLink = this.damListViewModel.damLinkFolder.split("/");
        const removeCurrentId = currentLink.slice(0, -1);
        const backLink = removeCurrentId.join("/");
        if (backLink) {
          this.damListViewModel.setDamLinkFolder(backLink);
        } else {
          this.damListViewModel.setDamLinkFolder("/root");
        }
      });
      __publicField(this, "clearItemSelection", () => {
      });
      __publicField(this, "handleItemSelection", (index, cmdKey, shiftKey, ctrlKey, contextClick = false) => {
        const { assets, collections, isSearch, damLinkFolder } = this.damListViewModel;
        const collectionId = damLinkFolder.split("/");
        let handleCollections = [];
        let handleAssets = [];
        if (!isNaN(+collectionId[collectionId.length - 1])) {
          handleAssets = assets.filter(
            (asset) => +asset[DAM_ASSETS_FIELD_KEY4.COLLECTION_ID] === +collectionId[collectionId.length - 1]
          );
          handleCollections = collections.filter(
            (collection) => +collection[DAM_COLLECTION_FIELD_KEY2.PARENT_ID] === +collectionId[collectionId.length - 1]
          );
        } else {
          if (isSearch) {
            handleAssets = assets;
            handleCollections = collections;
          } else {
            handleAssets = assets.filter((asset) => +asset[DAM_ASSETS_FIELD_KEY4.COLLECTION_ID] === 0);
            handleCollections = collections.filter(
              (collection) => collection[DAM_COLLECTION_FIELD_KEY2.PARENT_ID] === 0
            );
          }
        }
        let newSelectedCards;
        const cards = [...handleCollections, ...handleAssets].map((item, i) => ({
          ...item,
          index: i
        }));
        const card = index < 0 ? "" : cards[index];
        const newLastSelectedIndex = index;
        if (!cmdKey && !shiftKey && !ctrlKey && !contextClick) {
          newSelectedCards = [card];
        } else if (shiftKey) {
          if (this.damListViewModel.actionState.lastSelectedIndex >= index) {
            newSelectedCards = [].concat.apply(
              this.damListViewModel.actionState.selectedCards,
              cards.slice(index, this.damListViewModel.actionState.lastSelectedIndex)
            );
          } else {
            newSelectedCards = [].concat.apply(
              this.damListViewModel.actionState.selectedCards,
              cards.slice(this.damListViewModel.actionState.lastSelectedIndex + 1, index + 1)
            );
          }
        } else if (cmdKey || ctrlKey) {
          const foundIndex = this.damListViewModel.actionState.selectedCards.findIndex(
            (f) => f.id === card.id
          );
          if (foundIndex >= 0) {
            newSelectedCards = [
              ...this.damListViewModel.actionState.selectedCards.slice(0, foundIndex),
              ...this.damListViewModel.actionState.selectedCards.slice(foundIndex + 1)
            ];
          } else {
            newSelectedCards = [...this.damListViewModel.actionState.selectedCards, card];
          }
        } else if (contextClick) {
          const foundIndex = this.damListViewModel.actionState.selectedCards.findIndex(
            (f) => f.id === card.id
          );
          if (foundIndex >= 0) {
            newSelectedCards = [...this.damListViewModel.actionState.selectedCards];
          } else {
            newSelectedCards = [card];
          }
        }
        const finalList = cards ? cards.filter((f) => newSelectedCards.find((a) => a.id === f.id)) : [];
        this.damListViewModel.setActionState({
          selectedCards: finalList,
          lastSelectedIndex: newLastSelectedIndex
        });
        if (!this.isMulti) {
          if (this.props.onSelect) {
            const filterCollection = finalList.filter(
              (collection) => collection[DAM_ASSETS_FIELD_KEY4.TYPE]
            );
            return this.props.onSelect(filterCollection);
          }
        }
      });
      __publicField(this, "handleClickOutSite", (e) => {
        e.preventDefault();
        const inside = e.target.closest(".item_thumb");
        const checkChooseAction = e.target.closest(".choose-an-action");
        if (!inside && !checkChooseAction) {
          this.damListViewModel.setActionState({
            selectedCards: []
          });
        }
      });
      __publicField(this, "handleSelectClick", () => {
        if (this.props.onSelect) {
          const selectedCards = this.damListViewModel.actionState.selectedCards || [];
          const filterCollection = selectedCards.filter((collection) => collection?.id);
          if (filterCollection.length > 0) {
            this.props.onSelect(filterCollection);
          }
        }
      });
      const { viewModel, type, toolbar, isMulti } = props;
      this.viewModel = viewModel ? viewModel : null;
      this.damListViewModel = this.viewModel ? this.viewModel.getDamListViewModel() : null;
      this.damFormModalViewModal = this.viewModel ? this.viewModel.getDamFormViewModel() : null;
      this.type = type ?? "";
      this.toolbar = toolbar ?? true;
      this.isMulti = isMulti ?? false;
    }
    componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
      this.damListViewModel.setLoading();
      this.damListViewModel.setDamLinkFolder("root", {
        "filter[type]": this.type
      });
    }
    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.damListViewModel.resetObservableProperties();
    }
    render() {
      const { assets, status, collections, isSearch } = this.viewModel.damListViewModel;
      const { t } = this.props;
      if (status === PAGE_STATUS2.LOADING) {
        return /* @__PURE__ */ React11.createElement(Spinner2, null);
      }
      const tableRowHeader = [
        {
          id: "selection"
        },
        {
          Header: /* @__PURE__ */ React11.createElement("span", { className: "fw-semibold fs-14 text-gray-901 text-capitalize" }, t("txt_name")),
          accessor: DAM_COLUMN_INDICATOR.NAME,
          // accessor is the "key" in the data
          Cell: ({ row }) => /* @__PURE__ */ React11.createElement(
            "div",
            {
              className: `d-flex  ${this.damListViewModel.isList ? "" : " justify-content-center"}`
            },
            !row.original[DAM_ASSETS_FIELD_KEY4.TYPE] && !row.original[DAM_ASSETS_FIELD_KEY4.DOWNLOAD_URL] ? (
              // folder
              /* @__PURE__ */ React11.createElement(
                "div",
                {
                  className: `w-100 ${this.damListViewModel.isList ? "d-flex align-items-center" : "d-flex flex-column align-items-center justify-content-center"}`
                },
                /* @__PURE__ */ React11.createElement("div", { className: `${this.damListViewModel.isList ? "" : index_module_default.folder} pe-none` }, /* @__PURE__ */ React11.createElement(Folder_default, null)),
                /* @__PURE__ */ React11.createElement(
                  "span",
                  {
                    title: row.original[DAM_COLUMN_INDICATOR.NAME],
                    className: `${this.damListViewModel.isList ? "ms-32px text-color" : "text-center text-color lcl lcl-2 w-100 d-block w-space"} w-100`
                  },
                  /* @__PURE__ */ React11.createElement(CollectionName_default, { item: row.original }),
                  /* @__PURE__ */ React11.createElement("span", { className: "text-gray" }, row.original[DAM_COLUMN_INDICATOR.LAST_MODIFIED] ? !this.damListViewModel.isList && moment(new Date(row.original[DAM_COLUMN_INDICATOR.LAST_MODIFIED])).format(
                    "DD MMM, YYYY"
                  ) : null)
                )
              )
            ) : (
              // file
              /* @__PURE__ */ React11.createElement(
                "div",
                {
                  className: `w-100 ${this.damListViewModel.isList ? "d-flex align-items-center" : "d-flex flex-column align-items-center justify-content-center"}`
                },
                /* @__PURE__ */ React11.createElement(
                  "span",
                  {
                    className: this.damListViewModel.isList ? index_module_default.image_isList : index_module_default.image
                  },
                  row.original?.[DAM_ASSETS_FIELD_KEY4.TYPE] === "image" ? /* @__PURE__ */ React11.createElement(
                    Image2,
                    {
                      wrapperClassName: "w-100 h-100 pe-none",
                      className: "w-100 h-100 object-fit-cover",
                      src: `${row.original?.[DAM_ASSETS_FIELD_KEY4.DOWNLOAD_URL]}?${moment(
                        row.original[DAM_ASSETS_FIELD_KEY4.LAST_MODIFIED]
                      ).unix()}`
                    }
                  ) : /* @__PURE__ */ React11.createElement(
                    Image2,
                    {
                      visibleByDefault: true,
                      wrapperClassName: `w-100 h-100 align-items-center justify-content-center pe-none ${index_module_default.items_file}`,
                      src: HomeUtils_default.checkFileTypeFormData(row.original)
                    }
                  )
                ),
                /* @__PURE__ */ React11.createElement(
                  "span",
                  {
                    title: row.original[DAM_COLUMN_INDICATOR.NAME],
                    className: this.damListViewModel.isList ? "ms-3 text-color" : "d-block w-100 lcl lcl-1 p-2 text-color w-space"
                  },
                  row.original[DAM_COLUMN_INDICATOR.NAME]
                )
              )
            )
          )
        },
        {
          Header: /* @__PURE__ */ React11.createElement("span", { className: "fw-semibold fs-14 text-gray-901 text-capitalize" }, t("txt_size")),
          accessor: DAM_COLUMN_INDICATOR.FILE_SIZE,
          Cell: ({ row }) => /* @__PURE__ */ React11.createElement("div", { className: "d-flex" }, /* @__PURE__ */ React11.createElement("span", { className: "" }, row.original[DAM_ASSETS_FIELD_KEY4.TYPE] ? row.original[DAM_ASSETS_FIELD_KEY4.FILE_SIZE] : row.original[DAM_COLLECTION_FIELD_KEY2.FILE_SIZE], "KB"))
        },
        {
          Header: /* @__PURE__ */ React11.createElement("span", { className: "fw-semibold fs-14 text-gray-901 text-capitalize d-flex justify-content-center " }, t("txt_owner")),
          accessor: DAM_COLUMN_INDICATOR.OWNER,
          Cell: ({ row }) => /* @__PURE__ */ React11.createElement("div", { className: "d-flex justify-content-center ms-3" }, /* @__PURE__ */ React11.createElement("span", { className: "fw-normal fs-14 " }, row.original[DAM_COLUMN_INDICATOR.OWNER]))
        },
        {
          Header: /* @__PURE__ */ React11.createElement("span", { className: "fw-semibold fs-14 text-gray-901 text-capitalize d-flex justify-content-end me-5" }, t("txt_last_modified")),
          accessor: DAM_COLUMN_INDICATOR.LAST_MODIFIED,
          Cell: ({ row }) => /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement("div", { className: "fs-14 fw-normal d-flex justify-content-end me-5 " }, row.original.modified_date_org ? moment(new Date(row.original.modified_date_org)).format(
            "hh:mm A | dddd, MMMM DD YYYY"
          ) : null))
        }
      ];
      const collectionId = this.damListViewModel.damLinkFolder.split("/");
      let handleCollections = [];
      let handleAssets = [];
      if (!isNaN(+collectionId[collectionId.length - 1])) {
        handleAssets = assets.filter(
          (asset) => +asset[DAM_ASSETS_FIELD_KEY4.COLLECTION_ID] === +collectionId[collectionId.length - 1]
        );
        handleCollections = collections.filter(
          (collection) => +collection[DAM_COLLECTION_FIELD_KEY2.PARENT_ID] === +collectionId[collectionId.length - 1]
        );
      } else {
        if (isSearch) {
          handleAssets = assets;
          handleCollections = collections;
        } else {
          handleAssets = assets.filter((asset) => +asset[DAM_ASSETS_FIELD_KEY4.COLLECTION_ID] === 0);
          handleCollections = collections.filter(
            (collection) => collection[DAM_COLLECTION_FIELD_KEY2.PARENT_ID] === 0
          );
        }
      }
      return /* @__PURE__ */ React11.createElement(
        "div",
        {
          className: "position-relative col d-flex flex-column",
          id: "outside",
          onContextMenu: this.handleRightClick,
          onClick: this.handleClickOutSite
        },
        handleCollections || handleAssets ? /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(
          Table_default,
          {
            rowData: [...handleCollections, ...handleAssets],
            tableRowHeader,
            onSelect: this.handleSelect,
            isThumb: true,
            isList: this.damListViewModel.isList,
            dataThumb: [
              "selection",
              DAM_COLUMN_INDICATOR.FILE_SIZE,
              DAM_COLUMN_INDICATOR.OWNER,
              DAM_COLUMN_INDICATOR.LAST_MODIFIED
            ],
            listViewModel: this.damListViewModel,
            hasSubRow: false,
            _handleList: this._handleList,
            view: this.view,
            thumbColumnsNumber: 2,
            onDoubleClick: this.handleDoubleClick,
            createAssets: this.handleCreateAssets,
            onFilter: this.handleFilter,
            onSortby: this.handleSortBy,
            onRightClickItem: this.handleRightClickItem,
            onBackClick: this.handleBack,
            onSelectionChange: this.handleItemSelection,
            dataCollections: handleCollections,
            dataAssets: handleAssets,
            toolbar: this.toolbar
          }
        ), this.isMulti && this.damListViewModel.actionState.selectedCards.length > 0 && /* @__PURE__ */ React11.createElement("div", { className: "position-relative mb-3" }, /* @__PURE__ */ React11.createElement(
          Button,
          {
            className: "btn btn-success position-absolute zindex-5 bottom-0 end-0",
            onClick: this.handleSelectClick
          },
          `Choose ${this.damListViewModel.actionState.selectedCards.length} items`
        ))) : /* @__PURE__ */ React11.createElement(
          ComponentNoData_default,
          {
            icons: "/assets/images/ic_project.svg",
            title: t("create_your_1st_project"),
            width: "w-50"
          }
        )
      );
    }
  }
);
var AesirXDamComponent_default = withTranslation3()(withDamViewModel(AesirXDamComponent));

export {
  AesirXDamComponent_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
